import { User } from 'oidc-client';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { CallbackComponent } from "redux-oidc";
import { useAppDispatch, useAppSelector } from '../hooks/index';
import { getAllEntities } from '../redux/EntitiesSlice';
import { setIsHome } from '../redux/MiscSlice';
import { getAllTaxonomyVersions, selectAvailableVersions, setTaxonomyVersion, TaxonomyVersionInfo } from '../redux/TaxonomyVersionSlice';
import { getUserData, logerUser, UserRoleEnum } from '../redux/UserSlice';
import dateHelper from '../utils/dateHelper';
import userManager from "../utils/userManager";
import Page from './Page';




const Callback = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();


    React.useEffect(() => {
        dispatch(getAllTaxonomyVersions());       
    }, [])

    // Load the current taxonomy versions
    var versions: Array<TaxonomyVersionInfo> = useAppSelector(selectAvailableVersions);

    const successCallback = (user: User) => {
        dispatch(setIsHome(false));
        dispatch(getUserData(user.profile.oid))
            .then((result: any) => {
                var existingUser = result.payload as logerUser | undefined;

                if (existingUser) {

                    //if depreaction date has passed log user out
                    if (existingUser.deprecateDate != null && existingUser.deprecateDate != "") {
                        if (dateHelper.stringToDate(existingUser.deprecateDate) <= new Date()) {
                            userManager.signoutRedirect();
                        }
                    }

                    // Set up the default Taxonomy version
                    if (versions && versions.length > 0) {
                        var latestVersion = versions[versions.length - 1];
                        // NOTE - This call simply sets the current taxonomy version info - and does not call for updating any other slices.
                        setTaxonomyVersion(latestVersion);
                        console.log(latestVersion);
                    }
                    if (existingUser.role == UserRoleEnum.Admin) {
                        dispatch(getAllEntities())
                            .then((result: any) => {
                                history.push("/AdminMenu");
                            });
                    }
                    else if (existingUser.role == UserRoleEnum.EntityUser) {
                        if (existingUser.entityAuthorizations.length > 0) {
                            history.push("/EntityMenu");
                        } else {
                            userManager.signoutRedirect();
                        }
                    }
                }
                else {
                    userManager.signoutRedirect();
                }
            });
    };

    const errorCallback = (error: Error) => {
        console.error(error);
    };

    return (
        <Page>
            <CallbackComponent
                userManager={userManager}
                successCallback={successCallback}
                errorCallback={errorCallback}>
                <div>Redirecting...</div>
            </CallbackComponent>
        </Page>
    );
}

export default Callback;

